import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";
import { ShieldAlert } from "lucide-react";

export default function Disclaimer() {
  return (
    <>
      <Seo
        title="Disclaimer | Juwai Morning Teer"
        description="Full disclaimer for Juwai Morning Teer. This site is informational only and does not operate, promote, or facilitate betting or gambling."
        path="/disclaimer"
      />
      <PageShell>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight text-emerald-950">
          Disclaimer
        </h1>
        <div className="mt-6 rounded-2xl border border-amber-300/50 bg-amber-50 p-5 flex gap-3">
          <ShieldAlert className="w-5 h-5 text-amber-700 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-amber-900 leading-relaxed">
            <strong>Important Notice:</strong> Juwai Morning Teer is an
            informational website. We do not operate, organize, promote, sell
            tickets for, or facilitate betting or gambling. Results and other
            information are provided for informational/reference purposes only.
          </p>
        </div>
        <div className="prose prose-sm sm:prose-base max-w-none mt-6 text-slate-700 leading-relaxed">
          <p>
            All numbers, dates and descriptive information published on this
            site are added manually by the site administrator. No numbers are
            algorithmically or automatically generated. Common numbers pages
            provide reference figures only and carry no predictive guarantee.
          </p>
          <p>
            Visitors should not treat any information on this website as
            financial advice, gambling advice or as an invitation to
            participate in any wagering activity. If you believe you have a
            gambling problem, please seek help from an appropriate professional
            or helpline in your jurisdiction.
          </p>
        </div>
      </PageShell>
    </>
  );
}
